import groupModule from '../groupModule';

function groupGames(groupResources) {
    "ngInject";
    return {
        restrict: "A",
        templateUrl: groupResources.templates.groupGamesTemplate
    }
};

groupModule.directive("groupGames", groupGames);

export default groupGames;